import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index'
import { proxy4I18n } from '@xpeng/i18n'

const Error404 = () =>
  import(/* webpackChunkName: "BaseComponent" */ '@/views/pages/404')

Vue.use(Router)

let defaultRouterConfig = []

const Error404Router = [
  {
    path: '*',
    component: Error404
  }
]

let RouterConfig = [
  // {{
  //   path: '/KeyManagement',
  //   component: Layout,
  //   meta: {
  //     title: '密钥管理',
  //     icon: 'menu'
  //   },
  //   children: [
  //     {
  //       path: 'KeyApplication',
  //       name: 'KeyApplication',
  //       component: () => import('@/views/pages/KeyManagement/27KeyApplication'),
  //       meta: {
  //         title: '密钥申请',
  //         icon: 'check'
  //       }
  //     }
  //   ]
  // },
  // {{
  //   path: '/ConfigurationManagement',
  //   component: Layout,
  //   meta: {
  //     title: '配置管理',
  //     icon: 'home'
  //   },
  //   children: [
  //     {
  //       path: 'ApproverConfiguration',
  //       name: 'ApproverConfiguration',
  //       component: () => import('@/views/pages/ConfigurationManagement/ApproverConfiguration'),
  //       meta: {
  //         title: '审批人配置',
  //         icon: 'comment'
  //       }
  //     },
  //     {
  //       path: 'KeyConfiguration',
  //       name: 'KeyConfiguration',
  //       component: () => import('@/views/pages/ConfigurationManagement/KeyConfiguration'),
  //       meta: {
  //         title: '密钥配置',
  //         icon: 'comment'
  //       }
  //     }
  //   ]
  // }}}
  {
    path: '/CertificateManagement',
    name: 'CertificateManagement',
    component: Layout,
    meta: {
      title: '证书管理',
      icon: 'certificate'
    },
    children: [
      {
        path: '/CertificateManagement/CertificateApplication',
        name: 'CertificateApplication',
        component: () =>
          import('@/views/pages/CertificateManagement/CertificateApplication'),
        meta: {
          title: '证书申请',
          icon: 'certificate-apply'
        }
      },
      {
        path: '/CertificateManagement/CertificateQuery',
        name: 'CertificateQuery',
        component: () =>
          import('@/views/pages/CertificateManagement/CertificateQuery'),
        meta: {
          title: '证书查询',
          icon: 'certificate-query'
        }
      },
      {
        path: '/CertificateConfiguration',
        name: 'CertificateConfiguration',
        component: () =>
          import(
            '@/views/pages/CertificateManagement/CertificateConfiguration'
          ),
        meta: {
          title: '证书配置',
          icon: 'certificate-config'
        },
        children: [
          {
            path: '/CertificateManagement/TLSDevelopmentConfig',
            name: 'TLSDevelopmentConfig',
            component: () =>
              import(
                '@/views/pages/CertificateManagement/CertificateConfiguration/TLSDevelopmentConfig'
              ),
            meta: {
              title: 'TLS研发证书'
            }
          }
        ]
      },
      {
        path: '/CertificateManagement/CertificateUpdate',
        name: 'CertificateUpdate',
        component: () =>
          import('@/views/pages/CertificateManagement/CertificateUpdate'),
        meta: {
          title: '证书更新',
          icon: 'certificate-update'
        }
      }
    ]
  }
]
RouterConfig = proxy4I18n(RouterConfig)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

export { defaultRouterConfig, RouterConfig, Error404Router }

const router = new Router({
  routes: []
})

router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    next('/CertificateManagement')
  } else {
    next()
  }
})

export default router
